import React, { ButtonHTMLAttributes } from 'react';
import './styles.scss';

import { useCustomComponent } from '@/hooks';
import clsx from 'clsx';

export interface ButtonProps {
  variant?:
    | 'primary'
    | 'neutral-primary-900'
    | 'neutral-primary-750'
    | 'neutral-secondary-900';
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
  onClick?: () => void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  children: React.ReactNode;
}

const ButtonComponent: React.FC<ButtonProps> = ({
  variant = 'neutral-primary-750',
  onClick,
  disabled,
  ariaLabel,
  className,
  type = 'button',
  children,
}) => {
  return (
    <button
      className={clsx(
        'peptalk-button',
        `peptalk-button--${variant}`,
        className
      )}
      type={type}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {children}
    </button>
  );
};

export const Button: React.FC<ButtonProps> = (props: ButtonProps) => {
  const Component = useCustomComponent({
    componentName: 'Button',
    Component: ButtonComponent,
  });

  return <Component {...props} />;
};
